module.exports = __webpack_public_path__ + "fonts/MyriadPro-BoldIt.72a389a.ttf";